import SendIcon from '@mui/icons-material/Send';
import { Box, Button, IconButton, Stack } from '@mui/material';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { MentionsInput, Mention } from 'react-mentions';

import {
  mentionListReplyStyle,
  mentionListStyle,
  mentionStyle,
} from '../../../assets/styles/comments';
import { fetchUserList } from '../../../services/commentsService';

interface CommentTextFieldProps {
  handleAddComment: (text: string, userIDs: number[]) => void;
  handleCancelComment: () => void;
  replyMode?: boolean;
}

const CommentTextField = ({
  handleAddComment,
  handleCancelComment,
  replyMode,
}: CommentTextFieldProps) => {
  const [text, setText] = useState('');
  const [mentionedUserIDs, setMentionedUserIDs] = useState<number[]>([]);

  const handleChangeText = (value: string) => {
    setText(value);
  };

  const handleChangeMentionedUsers = (idList: number[]) => {
    setMentionedUserIDs(idList);
  };

  const intl = useIntl();
  const PLACEHOLDER_TEXT = replyMode
    ? intl.formatMessage({
        defaultMessage: 'Reply or tag others with @',
      })
    : intl.formatMessage({ defaultMessage: 'Comment or tag others with @' });

  const handleSendClicked = () => {
    handleAddComment(text, mentionedUserIDs);
    setText('');
  };

  const handleCancelClicked = () => {
    setText('');
    handleCancelComment();
  };

  return (
    <Stack
      direction={text ? 'column' : 'row'}
      alignItems='center'
      justifyContent='space-between'
      sx={{
        backgroundColor: replyMode ? '#F6F6F6' : '#fff',
        borderRadius: '6px',
        marginTop: replyMode ? 3 : 0,
        marginBottom: 1,
      }}
    >
      <Box
        paddingX={replyMode ? '12px' : '16px'}
        paddingY={replyMode ? '12px' : '12px'}
        width='100%'
      >
        <MentionsInput
          onChange={(_, newValue, __, mentionList) => {
            handleChangeText(newValue);
            const idArray = mentionList.map((mention) => {
              return parseInt(mention.id);
            });
            handleChangeMentionedUsers(idArray);
          }}
          value={text}
          placeholder={PLACEHOLDER_TEXT}
          style={replyMode ? mentionListReplyStyle : mentionListStyle}
        >
          <Mention trigger='@' data={fetchUserList} style={mentionStyle} />
        </MentionsInput>
      </Box>
      <Stack
        direction='row'
        justifyContent='flex-end'
        width={text ? '100%' : '45px'}
        spacing={2}
        borderTop={text ? '1px solid #D6D6D6' : 'none'}
        paddingX='8px'
        paddingY='12px'
      >
        {text && (
          <Button
            onClick={handleCancelClicked}
            variant='text'
            color='darkGray'
            sx={{
              textTransform: 'none',
              padding: 0,
            }}
          >
            Cancel
          </Button>
        )}
        <IconButton
          onClick={handleSendClicked}
          disabled={Boolean(!text)}
          sx={{
            backgroundColor: '#2449FC',
            '&:hover': {
              backgroundColor: '#1d3aca',
            },
            '&.Mui-disabled': {
              backgroundColor: '#D1D1D1',
            },
          }}
        >
          <SendIcon
            sx={{
              fontSize: 16,
              color: 'white',
            }}
          />
        </IconButton>
      </Stack>
    </Stack>
  );
};

export default CommentTextField;
